<template >
    <div class="garyaBg montserrat overflow-hidden">
      <section class="w-full  text-white h-full background-loreal">
    <div class="container mx-auto py-10 md:py-44 lg:py-24">
      <div class=" flexmobile   items-center ">
        <div class="lg:w-2/3 mb-8 lg:mb-0">
          <h1 class="text-3xl sm:text-md md:text-5xl  font-bold mb-6">
            L'Oréal Groupe
                  </h1>
          <h2 class="text-2xl md:text-4xl  font-medium">
            Information Architecture Redesign
          </h2>
        </div>
        <div class="lg:w-full animate__animated animate__zoomInRight">
          <img
          loading="lazy"
          src="https://res.cloudinary.com/dr5bsqos2/image/upload/v1727325830/uulua0lqm3vq6wc0k824.png"
            alt="Eater Chicago website mockup"
            class="w-[80%] ml-60"
          />
        </div>
      </div>
    </div>
  </section>

  <!-- end of first hero section -->
  <div class="flex flex-col ">
  <main class="flex flex-col items-start px-4 md:px-20 w-full">
    
    <!-- section two -->
    <section class="  w-full">
      <h1 class="self-start text-4xl font-semibold text-white">My Role</h1>
      <div class="flex flex-col mt-10 md:flex-row justify-between">
        <!-- Main content -->
         
        <div class="w-full md:w-10/12">
          <section class="text-lg  text-amber-50 max-w-full md:max-w-[939px]">
            <h1 class="">
              <span class="text-lg text-amber-100">Streamlined website IA</span>
              <span class=" text-lg "> with content </span>
              <span class="pt-6 text-lg  text-amber-100">inventory, affinity diagramming, and search log analysis</span>
            </h1>
            <p class="pt-6 text-lg ">
              Used Optimal Workshop for 
              <span class=" pt-6 text-lg  text-amber-100">Card Sorts, Tree Tests, and Chalkmark tests</span>.
            </p>
            <p class="pt-6 text-lg">
              Identified task success and abandonment rates.
            </p>
            <p class="pt-6 text-lg">
              <span class="text-amber-100">Analyzed user feedback</span> and test data iteratively.
            </p>
          </section>
        </div>
        
        <!-- Image for larger screens -->
        <div class="hidden md:flex md:w-3/12 justify-center -mt-10">
          <img  class="max-w-full" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726656897/Line_9_yqnb1d.png" alt="">
        </div>
        
        <!-- Aside section -->
        <aside class="flex flex-col ml-0 md:ml-5 w-full md:w-3/12 -mt-16">
          <div class="flex flex-col items-start text-2xl md:text-3xl text-white">
            <h1 class="self-start text-4xl font-semibold text-white">Duration</h1>
            <p class="pt-3 text-lg  text-amber-50">8 weeks</p>
            <h1 class="pt-6 md:pt-10 self-start text-4xl font-semibold text-white">Group of 3</h1>
            <h1 class="pt-6 md:pt-10 self-start text-4xl font-semibold text-white">Tools</h1>
            <p class="pt-6 text-lg text-amber-50">
              Figma, Optimal Sort, Google Sheets
            </p>
          </div>
        </aside>
      </div>
    </section>
    <!-- end of section two -->
  </main>
</div>

  <!-- Add responsiveness to other sections similarly -->
  <div>
  <main>
    <!-- section four -->
    <section class="md:mt-44 mt-10 px-4 md:px-10 background-loreal2 h-auto md:h-[340px] py-10">
      <div class="flex flex-col md:flex-row justify-between items-center text-center">
        
        <div class="flex-1 mb-6 md:mb-0">
          <p class="text-white text-xl md:text-2xl">Increased User Onboarding by</p>
          <p class="text-white pt-6 text-4xl md:text-5xl font-bold">36%</p>
        </div>
        
        <div class="flex-1 mb-6 md:mb-0">
          <p class="text-white text-xl md:text-2xl">Customer Satisfaction Score</p>
          <p class="text-white pt-6 text-4xl md:text-5xl font-bold">4.5</p>
        </div>
        
        <div class="flex-1">
          <p class="text-white text-xl md:text-2xl">Reduced Bounce Rate by</p>
          <p class="text-white pt-6 text-4xl md:text-5xl font-bold">15%</p>
        </div>
        
      </div>
    </section>
    <!-- end of section four -->
  </main>
</div>

<main class="px-4 md:px-20 mx-auto">
  <!-- five section -->
  <section class="mt-16 md:mt-24">
    <div class="flex flex-col md:flex-row gap-10 justify-between">
      
      <!-- About Text -->
      <div class="text-white text-base  md:w-1/2 mr-16">
       <h1 class="font-semibold pt-10 md:pt-20 text-2xl md:text-4xl">About</h1>
        <p class="pt-6 text-lg md:pt-16">
          L'Oréal leads top cosmetics brands as a parent company,
          providing confidence-boosting beauty products within every
          niche in the industry. From skincare to hair care to makeup, L’Oréal brands are for every audience. Its website is a hub that hosts information about L’Oréal Groupe’s mission, practices, innovation, and more.
        </p>
      </div>
      
      <!-- Image 1 -->
      <div class=" md:w-1/2 h-auto">
        <img  loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726657288/samsung_qr1kny.png" alt="Samsung image" class="w-full h-auto">
      </div>
    </div>

    <div class="flex flex-col md:flex-row mt-10 md:mt-20 gap-10 md:gap-14 justify-between">
      
      <!-- Image 2 -->
      <div class="w-full md:w-1/2 h-auto md:w-[40%] ">
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726657333/powder_a5opj8.png" alt="Powder image" class="w-full h-auto ">
      </div>
      
      <!-- Current Website Navigation Text -->
      <div class="text-white text-base  md:w-1/2 ml-16 mt-14">
        <h1 class="font-semibold text-2xl md:text-4xl">Current Website Navigation</h1>
        <p class="pt-20 text-lg md:pb-6">
          The website serves as a central hub, providing valuable information about L'Oréal Groupe's mission,
          practices, and innovation.
        </p>
        <p class=" text-lg">
          While the website navigation is relatively straightforward, an effort was made to streamline it further. By <span class="text-amber-100">condensing the main categories and reducing the number of subcategories,</span> essential content could be prioritized to enhance the overall user experience. This approach ensures that all significant topics are covered without cluttering the drop-down menus, resulting in a more optimized and user-friendly website.
        </p>
      </div>
      
    </div>
  </section>
</main>

        <!-- section sex -->
        <section class="flex container mx-auto flexmobile2 md:w-[90%]  mt-10 md:mt-32  justify-center items-center flex-col rounded-none">
    <div class="relative justify-center items-center">
      <!-- Image mockup -->
      <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726657414/MacBook_Pro_awxwkk.png" alt="MacBook Mockup" class="mockup-image">
      <!-- Video overlay -->
      <video
        class="   w-[100%] absolute h-[85.6%] top-2   md:top-8  "
        autoplay
        muted
        loop
      >
        <source src="https://res.cloudinary.com/dkdzcp4au/video/upload/v1726658794/loreal_video_eoydst.mov" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  </section>
          <!-- section seven -->
          <section class=" px-4 md:px-20 mt-10 md:mt-56 mx-auto">
  <section class="md:w-full">
    <h1 class="text-3xl md:text-4xl mb-6 md:mb-10 font-semibold text-white">In a nutshell</h1>
    <div class="flex flex-col md:flex-row justify-between md:gap-10">
      
      <!-- Shortcomings of the Website -->
      <div class="w-full md:w-[45%]">
        <section class="flex flex-col">
          <p class="text-amber-100 text-2xl md:text-3xl font-semibold pt-6">Shortcomings of the Website</p>
          <ul class=" text-white pt-6 text-lg md:pb-6">
            <li class="pt-6 text-lg ">4 level menu items; difficult to navigate</li>
            <li class="pt-6 text-lg">Confusing category names</li>
            <li class="pt-6 text-lg ">For the “Careers” page, difficulty in applying all filters at once</li>
            <li class="pt-6 text-lg">Complex and time-consuming navigation to search for relevant data</li>
          </ul>
        </section>
      </div>
      
      <!-- Hidden Image on Mobile -->
      <div class="hidden md:block  ">
        <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726656897/Line_9_yqnb1d.png" alt="Line image">
      </div>
      
      <!-- How the Redesign Helped -->
      <div class="w-full md:w-[40%] mt-10 md:mt-0">
        <p class="text-amber-100 text-2xl md:text-3xl font-semibold pt-6">How did the Redesign help?</p>
        <ul class=" text-white pt-6 text-lg md:pb-6">
          <li class="pt-6 text-lg">Reduced menu items to 3 levels</li>
          <li class="pt-6 text-lg ">Renamed categories for better understanding</li>
          <li class="pt-6 text-lg ">Designed "Sort & Filter" pop-up to filter everything at once</li>
          <li class="pt-6 text-lg ">Designed a carousel for cohesive and fast navigation</li>
        </ul>
      </div>
      
    </div>
  </section>
</section>

    
  <!-- Identifying Intended Target Tasks -->
  <section class="px-4 md:px-20 mx-auto mt-32 md:mt-44">
  <div>
    <h1 class="text-3xl md:text-4xl mb-6 md:mb-10 font-semibold text-white">Identifying Intended Target Tasks</h1>
    <section class="w-full text-base md:text-2xl font-medium text-amber-50">
      <p class="pt-6 text-lg">
        Since the L'Oréal website is strictly about the business's information, it is likely 
        <span class="text-amber-100">everyday consumers are not intended to be the target users.</span> 
        The website's current content leads visitors to complete one of two actions:
      </p>
      <ol class="mt-5 text-amber-100 md:text-lg">
        <li class="pt-4">Business Interactions</li>
        <li class="pt-4">Learning about L'Oréal</li>
      </ol>
    </section>
  </div>
</section>

 
 <LorealProjectTwo/>
 <LorealprojectThree/>
 <LorealProjectFour/>
</div>
</template>


<script>
import LorealProjectTwo from './LorealProjectTwo.vue'
import LorealprojectThree from './LorealProjectThree.vue'
import LorealProjectFour from './LorealProjectFour.vue'
export default {
  name: 'LorealProject',
  components:{
    LorealProjectTwo,
    LorealprojectThree,
    LorealProjectFour
  },
};
</script>


<style>
.background-loreal{
  background: linear-gradient(180deg, rgba(129, 123, 104, 0.70) 0%, rgba(72, 69, 59, 0.60) 40.11%, rgba(44, 41, 37, 0.70) 57.05%, rgba(29, 28, 25, 0.80) 72.86%, rgba(22, 21, 20, 0.95) 83.31%, #0F0E0E 95.41%);

}
@media (max-width:640px) {
  .background-loreal{
    background-image: url("https://res.cloudinary.com/dkdzcp4au/image/upload/v1726657108/lorealcover_zjhptg.png");
    background-size: cover;
}
.background-loreal2{
    background-image: url("https://res.cloudinary.com/dkdzcp4au/image/upload/v1726657108/lorealcover_zjhptg.png");
    background-size: cover;
    background-repeat: no-repeat;
}
}
.background-loreal2{
    background-image: url("https://res.cloudinary.com/dkdzcp4au/image/upload/v1726657108/lorealcover_zjhptg.png");
    background-size: contain;
}



@media (max-width:640px){
    .flexmobile2{
        display: block;
        margin-left: 0;
        padding: 10px;
        gap: 0 !important;
        font-size: 20px;
    }
    
    .max-w-small-mobile{
        max-width: 100%;
        width: 100%;
    }
}

</style>





